module.exports = __webpack_public_path__ + "static/media/1007001BE.94004513.jpg";